import React, { FC } from 'react';

interface ISpinner {
  customClass?: string;
}

const Spinner: FC<ISpinner> = ({ customClass }): JSX.Element => {
  return (
    <div className={`spinner-component ${customClass}`}>
      <div className="spinner">
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
        <div className="spinner__cell">
          <div />
        </div>
      </div>
    </div>
  );
};

export default Spinner;
